var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 8.4375C9.8291 8.4375 11.7188 6.54785 11.7188 4.21875C11.7188 1.88965 9.8291 0 7.5 0C5.1709 0 3.28125 1.88965 3.28125 4.21875C3.28125 6.54785 5.1709 8.4375 7.5 8.4375ZM11.25 9.375H9.63574C8.98535 9.67383 8.26172 9.84375 7.5 9.84375C6.73828 9.84375 6.01758 9.67383 5.36426 9.375H3.75C1.67871 9.375 0 11.0537 0 13.125V13.5938C0 14.3701 0.629883 15 1.40625 15H13.5938C14.3701 15 15 14.3701 15 13.5938V13.125C15 11.0537 13.3213 9.375 11.25 9.375Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.074e86039980bdb5efc79092af832bdb.svg";
export { ForwardRef as ReactComponent };